<svelte:head>
  <title>Needs | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="level">
  <div class="level-left">
    <div class="level-item level-can-wrap">
      <div class="block">
        <div>
          <div class="title">Your needs</div>
        </div>
        <div>
          <div class="subtitle">
            Make local businesses aware of resources that your charity needs.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="level-right">
    <div class="level-item">
      <div class="buttons">
        <a class="button is-primary" on:click={createNeed}>
          <strong>Create need</strong>
        </a>
      </div>
    </div>
  </div>
</div>

{#if allItems != undefined}
  {#if allItems.length > 0}
    <table class="table is-fullwidth is-hoverable">
      <tbody>
        {#each allItems as item}
          <tr>
            <td style="width:100%;">
              <div
                class="is-pulled-left"
                style="width:60px; height:60px; margin-right:20px;">
                {#if item.data.images?.[0]}
                  <img
                    src={item.data.images[0]}
                    style="max-height:60px;max-width:60px;" />
                {:else}
                  <img
                    src="/assets/img/box.png"
                    style="max-height:60px;max-width:60px; background-color:lightgrey" />
                {/if}
              </div>
              <div
                class="is-flex is-flex-direction-row align-items is-align-items-center"
                style="height:60px;">
                <a href={$url('../../need/' + item.id)}>{item.data.title || 'Untitled'}</a>
              </div>
            </td>
            <td style="min-width:100px;">
              <div
                class="is-flex is-flex-direction-row align-items is-align-items-center"
                style="height:60px;">
                <span class="tag is-info is-light">{item.data.status}</span>
              </div>
            </td>

            <!-- Will use this for offers from businesses -->

            <!-- <td style="min-width:100px;">
              <div
                class="is-flex is-flex-direction-row align-items is-align-items-center"
                style="height:60px;"
              >
                {#if item.data.requests && item.data.requests.length > 0}
                  <span class="tag is-success is-light">
                    {`Request${item.data.requests.length > 1 ? 's' : ''} made${
                      item.data.requests.length > 1
                        ? ` (${item.data.requests.length})`
                        : ''
                    }`}
                  </span>
                {/if}
              </div>
            </td> -->
          </tr>
        {/each}
      </tbody>
    </table>
  {:else}
    <article class="message is-success">
      <div class="message-body">
        You have not yet published any needs.
        <a on:click={createNeed}>Create a need</a>.
      </div>
    </article>
  {/if}
{/if}

<script lang="ts">
  import { appState } from '../../../lib/appState';
  import { goto, url } from '@sveltech/routify';

  let allItems: any[] = [];

  let firebase = window.firebase;

  getNeeds();

  function createNeed() {
    $goto('/charity/needs/create');
  }

  async function getNeeds() {
    firebase
      .firestore()
      .collection('needs_v1')
      .where('charity', '==', $appState.user!.charity)
      .onSnapshot((snap) => {
        allItems = snap.docs
          .map((doc) => ({ id: doc.id, data: doc.data() }))
          .sort((a, b) => (b.data.created > a.data.created ? 1 : -1));
      });
  }
</script>
